export default __webpack_public_path__ + "static/media/6.7372867f.PNG";